// @ngInject
function UserTimeStampingDialogService($uibModal, TimeStampingApiService) {

    return {
        showDialog: showDialog,
        showDialogLoginless: showDialogLoginless
    };

    function showDialog() {

        var modalDefaults = {
            backdrop: 'static',
            keyboard: false,
            controller: 'UserTimeStampingDialogServiceController as vm',
            templateUrl: 'main/timestamp/userTimeStampingDialog/userTimeStampingDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            locations: function() {
                return TimeStampingApiService.getLocations();
            },
            previousTimeStampDays: function() {
                return TimeStampingApiService.getLatestTimeStampDays(5);
            },
            totalTimeThisMonth: function() {
                var now = new Date();
                var startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 3, 0, 0, 0);
                return TimeStampingApiService.getWorkingTime(startOfMonth, now);
            },
            loginless: function() {
                return false;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }

    function showDialogLoginless() {

        var modalDefaults = {
            backdrop: 'static',
            keyboard: false,
            controller: 'UserTimeStampingDialogServiceController as vm',
            templateUrl: 'main/timestamp/userTimeStampingDialog/userTimeStampingDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            locations: function() {
                return TimeStampingApiService.getLocations();
            },
            previousTimeStampDays: function() {
                return TimeStampingApiService.getLatestTimeStampDays(5);
            },
            totalTimeThisMonth: function() {
                var now = new Date();
                var startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 3, 0, 0, 0);
                return TimeStampingApiService.getWorkingTime(startOfMonth, now);
            },
            loginless: function() {
                return true;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function UserTimeStampingDialogServiceController($rootScope, $uibModalInstance, $scope, $interval, locations, totalTimeThisMonth,
    previousTimeStampDays, TimeStampingApiService, AuthService, loginless, $translate, ToasterService) {
    var vm = this;

    var stampHistoryGrid = {};
    var timeUpdatePromise = {};
    var jqCurrentTimeElement = $("#currentTimeSection");

    var timeStampDaysGrid = {};
    vm.buttonsAreDisabled = false;


    vm.currentUser = {};

    vm.locations = locations;

    vm.previousTimeStampDays = _.sortBy(previousTimeStampDays.data, 'date').reverse();
    vm.previousTimeStamps = (vm.previousTimeStampDays.length !== 0) ?
                            _.sortBy(vm.previousTimeStampDays[0].userTimeStamps, 'dateTime').reverse() :
                            [];
    vm.totalTimeThisMonth = totalTimeThisMonth.data;

    vm.stampIn = stampIn;
    vm.stampOut = stampOut;
    vm.captureStampHistoryGrid = captureStampHistoryGrid;
    vm.captureTimeStampDaysGrid = captureTimeStampDaysGrid;
    vm.updateTimeStamp = updateTimeStamp;
    vm.changeDisplayedTimeStampDay = changeDisplayedTimeStampDay;
    vm.updateTimeStampDay = updateTimeStampDay;
    vm.currentLocalTime = new Date();

    vm.closeModal = closeModal;

    vm.stampInDisabled = false;
    vm.stampOutDisabled = false;

    vm.stampCreationRequest = {
        note: "",
        location: (vm.locations != null && vm.locations.length !== 0) ? vm.locations[0] : {}
    };

    vm.isLoginLessTimeStamping = loginless;

    activate();

    function activate() {
        setTimeStampButtonsAvailability();

        timeUpdatePromise = $interval(updateLocalTime, 1000);

        if (vm.isLoginLessTimeStamping) {
            TimeStampingApiService.getMe().then(function(response) {
                vm.currentUser = response;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });
        } else {
            vm.currentUser = $rootScope.currentUser;
        }

        if (vm.isLoginLessTimeStamping) {
            AuthService.getUser().then(function(response) {
            });
        }
    }

    function updateLocalTime() {
        vm.currentLocalTime = new Date();
    }

    function stampIn() {
        vm.buttonsAreDisabled = true;
        $uibModalInstance.startLoadingSpinner();
        console.log("Stamping in...");
        TimeStampingApiService.stampIn(vm.stampCreationRequest).then(function() {
            getPreviousTimeStamps();
        }, function(error) {
            console.log(error);
            ToasterService.showError(error);
        }).finally(function() {
            $uibModalInstance.stopLoadingSpinner();
            vm.buttonsAreDisabled = false;
        });
    }

    function stampOut() {
        vm.buttonsAreDisabled = true;
        $uibModalInstance.startLoadingSpinner();
        console.log("Stamping out...");
        TimeStampingApiService.stampOut(vm.stampCreationRequest).then(function(reponse) {
            getPreviousTimeStamps();

            var now = new Date();
            var startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 3, 0, 0, 0);
            return TimeStampingApiService.getWorkingTime(startOfMonth, now).then(function(response) {
                vm.totalTimeThisMonth = response.data;
            }, function(error) {
                console.log(error);
                ToasterService.showError(error);
            });
        }, function(error) {
            console.log(error);
            ToasterService.showError(error);
        }).finally(function() {
            $uibModalInstance.stopLoadingSpinner();
            vm.buttonsAreDisabled = false;
        });
    }

    function getPreviousTimeStamps() {
        TimeStampingApiService.getLatestTimeStampDays(5).then(function(response) {
            vm.previousTimeStampDays = _.sortBy(response.data, 'date').reverse();
            vm.previousTimeStamps = _.sortBy(vm.previousTimeStampDays[0].userTimeStamps, 'dateTime').reverse();
            setTimeStampButtonsAvailability();
        }, function(error) {
            console.log(error);
        });
    }

    function captureStampHistoryGrid(s) {
        stampHistoryGrid = s;
    }

    function updateTimeStampDay(timeStampDay) {
        if (timeStampDay.note !== "") {
            timeStampDay.notify = true;
        }
        $uibModalInstance.startLoadingSpinner();
        TimeStampingApiService.updateTimeStampDay(timeStampDay).then(function(response) {
            console.log("Successfully updated the timeStampDay");
        }, function(error) {
            console.log(error);
        }).finally(function() {
            $uibModalInstance.stopLoadingSpinner();
        });
    }

    function changeDisplayedTimeStampDay(timeStampDay) {
        vm.previousTimeStamps = _.sortBy(timeStampDay.userTimeStamps, 'dateTime').reverse();
    }

    function captureTimeStampDaysGrid(s) {
        timeStampDaysGrid = s;
    }

    function updateTimeStamp(timeStamp) {
        console.log("Timestamp to update:");
        console.log(timeStamp);
    }

    function closeModal() {
        $interval.cancel(timeUpdatePromise);
        if (vm.isLoginLessTimeStamping) {
            AuthService.logOut();
        }
        $uibModalInstance.close();
    }

    function setTimeStampButtonsAvailability() {
        console.log("Getting current type");
        var orderedTimeStamps = _.sortBy(vm.previousTimeStamps, 'dateTime').reverse();
        var currentTimeStampSystemType = "";
        if (orderedTimeStamps[0] !== undefined) {
            currentTimeStampSystemType = orderedTimeStamps[0].timeStampType.timeStampSystemType;
        }

        if (currentTimeStampSystemType === 'in') {
            vm.stampInDisabled = true;
            vm.stampOutDisabled = false;
        } else if (currentTimeStampSystemType === 'out') {
            vm.stampInDisabled = false;
            vm.stampOutDisabled = true;
        } else {
            vm.stampInDisabled = false;
            vm.stampOutDisabled = true;
        }
    }

}

angular
    .module('timestamp.userTimeStamping', [])
    .service('UserTimeStampingDialogService', UserTimeStampingDialogService)
    .controller('UserTimeStampingDialogServiceController', UserTimeStampingDialogServiceController);
